import React from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 35px;
  height: 22px;
`;

const StyledToggle = styled.span<{selected?: boolean;}>`

  position: absolute;
  cursor: pointer;
  top: 2px;
  left: 2px;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 14px;
  border-radius: 14px;
  background-color: ${props => props.selected? '#3174ad' : '#cccccc'};
  
  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    top: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;

    ${props => props.selected? 'transform: translateX(13px);' : null}
  }

`;

export const Toggle = ({ selected=false, onClick }: { selected?: boolean, onClick?: any }) => {
  return (
    <StyledContainer>
      <StyledToggle onClick={onClick} selected={selected}/>
    </StyledContainer>
  )
}